import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import { environment } from 'src/environments/environment';
import {ConfService} from './conf.service';
import {EmailtemplateService} from './emailtemplate.service';
import {ConnecttocrudService} from './connecttocrud.service';
import { EnvironmentManagerComponent } from './settings/environment-manager/environment-manager.component';
import {Validators} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentCreatorService {

  selectedAPIGateway = {
    gateway: 'apiplatform',
    image: './assets/img/partnerOnboarding/api.png',
    description: 'Default',
    value: 'default',
    provider: 'apiplatform.io',
    gatewayURL: '',
    gateway_configurations: {}
  };
  environmentResponseArray: any;

  settingsPayload = {
    partner_name: '',
    account_name: '',
    environment_type: '',
    partner: '',
    account: '',
    email: '',
    phone_number: '',
    environments: [
      {
        name: '',
        type: '',
        cloud: [
          {
            type: 'aws',
            region: 'US-East (N.Virginia)',
            'is_default': true,
            regions: ['US-East (N.Virginia)'],
            audit_logs: [{
              action: 'CREATE',
              by: localStorage.getItem('signInEmail'),
              at: Date.now()
            }]
          }
        ],
        display_name: '',
        is_validation_complete: false,
        is_creation_complete: true,
        is_enabled: true,
        services: [
          {
            name: 'Secrets Manager',
            type: 'secretsmanager',
            configurations: [
              {
                'name': 'Default',
                'providerName': 'apiplatform.io',
                'image': './assets/img/partnerOnboarding/api.png',
                'description': 'apiplatform\'s encryption mechanism',
                'owner': 'apiplatform.io',
                'is_default': true,
                'audit_logs': [{
                  action: 'CREATE',
                  by: localStorage.getItem('signInEmail'),
                  at: Date.now()
                }]
              }
            ]
          },
          {
            name: 'Databases',
            type: 'databases',
            configurations: [
              {
                database_name: '',
                database_type: '',
                region: '',
                'is_default': true,
                database_attributes: {},
                'audit_logs': [{
                  action: 'CREATE',
                  by: localStorage.getItem('signInEmail'),
                  at: Date.now()
                }]
              }
            ]
          }
        ],
        'audit_logs': [
          {
            action: 'CREATE',
            by: localStorage.getItem('signInEmail'),
            at: Date.now()
          }
        ]
      }
    ],
    is_enabled: true,
    subscriptions: {
      providers: [],
      platform_services: [],
      platform_service_categories: []
    },
    logo: '',
    brand_image: ''
  };

  environmentPayloadInput: any;
  patchAdminPartnerSettingsRetries = 0;
  createdRoleId: any;

  rolePayload = {
    role: '',
    permission_groups: [],
    permissions: [],
    roles: [],
    exclusions: [],
    partner: '',
    account: '',
    description: '',
    type: 'account'
  };

  htmlContent: string;

  iterationCount = 1000;
  keySize = 128;
  passphrase = environment.cipheringPhrase;

  constructor(public platform: LeftpanelComponent,
              private confPost: ConfService,
              private envManagerComponentInstance: EnvironmentManagerComponent,
              private emailTemplateInstance: EmailtemplateService,
              private _service: ConnecttocrudService) { }

  
  async setUpEnvironment(environmentType, partnerShortCode, password, confirmPassword, databasesPayload, databaseSelected, adminPkey) {
    return new Promise(async (resolve, reject) => {
      localStorage.setItem('partnerKey', adminPkey);
      const configurationsForEnvCreation = {};
      configurationsForEnvCreation[environmentType] = {};
      this.keySize = this.keySize / 32;
      const partnerAccount = partnerShortCode;

      const settingsPayload = JSON.parse(JSON.stringify(this.settingsPayload));

      settingsPayload.partner_name = partnerShortCode;
      settingsPayload.account_name = partnerShortCode;
      settingsPayload.environments[0]['partner_name'] = partnerShortCode;
      settingsPayload.environments[0]['account_name'] = partnerShortCode;
      settingsPayload.environment_type = environmentType;

      if (environmentType === 'prod') {
        settingsPayload.partner = partnerShortCode;
        settingsPayload.account = partnerAccount;
        settingsPayload.environments[0].name = partnerShortCode;
        settingsPayload.environments[0].display_name = 'Production';
      } else {
        settingsPayload.partner = environmentType + '-' + partnerShortCode;
        settingsPayload.account = environmentType + '-' + partnerAccount;
        settingsPayload.environments[0].name = environmentType + '-' + partnerShortCode;
        switch (environmentType) {
          case 'staging':
            settingsPayload.environments[0].display_name = 'Staging';
            break;
          case 'qa':
            settingsPayload.environments[0].display_name = 'QA';
            break;
          case 'dev':
            settingsPayload.environments[0].display_name = 'Development';
            break;
          case 'admin':
            settingsPayload.environments[0].display_name = 'Administration';
            break;
          default:
            settingsPayload.environments[0].display_name = environmentType;
            break;
        }
      }

      settingsPayload.environments[0].type = environmentType;

      configurationsForEnvCreation[environmentType]['environmentResponseArray'] = [];
      configurationsForEnvCreation[environmentType]['envPartner'] = '';

      await this.confPost.getPartner('admin-' + partnerShortCode, 'admin-' + partnerShortCode).toPromise().then(data => {
        Promise.resolve(this.getPartnerKey('admin-' + partnerShortCode, 'admin-' + partnerShortCode, data['partnerKey'])).then(async response1 => {
          const item = {};
          if (environmentType === 'prod') {
            item['partner'] = partnerShortCode;
          } else {
            item['partner'] = environmentType + '-' + partnerShortCode;
          }
          item['partner_name'] = partnerShortCode;
          item['account_name'] = partnerShortCode;
          item['environment_type'] = environmentType;
          item['primary_email'] = data['primary_email'];
          item['primary_phone'] = data['primary_phone'];
          item['primaryRegion'] = data['primaryRegion'];
          item['primaryLanguage'] = data['primaryLanguage'];
          item['partnerKey'] = response1['partnerKey'];
          item['partner_organization_type'] = data['partner_organization_type'];
          item['partner_organization_size'] = data['partner_organization_size'];
          item['anticipated_api_count'] = data['anticipated_api_count'];
          item['expected_api_hits'] = data['expected_api_hits'];
          item['partner_organization'] = data['partner_organization'];
          item['currentPlan'] = 'Enterprise';
          item['planHistory'] = [
            {
              planName: 'Enterprise',
              createdDate: Date.now(),
              removedDate: ''
            }
          ]
          ;
          item['accounts'] = [
            {
              // account: partnerAccount,
              account_desc: 'default',
              account_email: item['primary_email'],
              account_phone: item['primary_phone'],
              account_roles: [],
              entities: [],
              operations: []
            }
          ];
          item['isActive'] = true;
          if (environmentType === 'prod') {
            item['accounts'][0]['account_id'] = partnerAccount;
          } else {
            item['accounts'][0]['account_id'] = environmentType + '-' + partnerAccount;
          }

          // if (data['databases'].length > 0) {
          //   item['databases'] = data['databases'];
          //   item['defaultDatabaseType'] = data['defaultDatabaseType'];
          // } else {
          //   item['databases'] = [];
          //   item['defaultDatabaseType'] = data['defaultDatabaseType'];
          // }
          settingsPayload.email = data['primary_email'];
          settingsPayload.phone_number = data['primary_phone'];
          configurationsForEnvCreation[environmentType]['partnerPayload'] = item;
          configurationsForEnvCreation[environmentType]['settingsPayload'] = settingsPayload;

          await this.initiateEnvironmentCreation(configurationsForEnvCreation, environmentType, databasesPayload, databaseSelected, partnerShortCode, password, confirmPassword).then(async response1 => {
            if (response1 === 'success') {
              resolve({partnerKey: item['partnerKey'], environmentResponseArray: this.environmentResponseArray});
            } else {
              reject('failed');
            }
          });
        }, error => {
          reject('failed');
        });
      }, error => {
        reject('failed');
      });
    });
  }

  async getPartnerKey(partner, account, key) {
    return new Promise(async (resolve, reject) => {
      await this.confPost.generatePartnerKey(partner, account, key).subscribe(response => {
        resolve({partnerKey: response['token']});
      });
    });
  }

  async initiateEnvironmentCreation(configurationsForEnvCreation, environmentPayload, databasesPayload, databaseSelected, partnerShortCode, password, confirmPassowrd) {
    return new Promise(async (resolve, reject) => {
      if (password === confirmPassowrd) {
        // this.loading1 = true;
        const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        for (const service of configurationsForEnvCreation[environmentPayload].settingsPayload.environments[0].services) {
          if (service['type'] === 'secretsmanager') {
            if (service['configurations'][0]['providerName'] === 'Default' || service['configurations'][0]['providerName'] === 'apiplatform.io') {
              configurationsForEnvCreation[environmentPayload]['partnerPayload']['ralam'] = iv;
              configurationsForEnvCreation[environmentPayload]['partnerPayload']['shash'] = salt;
              configurationsForEnvCreation[environmentPayload]['partnerPayload']['account_password'] = this.platform.encrypt(salt, iv, this.passphrase, password, this.keySize, this.iterationCount);
              configurationsForEnvCreation[environmentPayload]['partnerPayload']['accounts'][0]['account_password'] = this.platform.encrypt(salt, iv, this.passphrase, password, this.keySize, this.iterationCount);
            } else {
              configurationsForEnvCreation[environmentPayload]['partnerPayload']['account_password'] = '';
              configurationsForEnvCreation[environmentPayload]['partnerPayload']['accounts'][0]['account_password'] = '';
            }
          }
        }
        for (const service of configurationsForEnvCreation[environmentPayload].settingsPayload.environments[0].services) {
          if (service.type === 'databases') {
            if (databasesPayload.length > 0) {
              databasesPayload[0]['connection_provider'] = 'external';
              databasesPayload[0]['is_default'] = true;
              if (databasesPayload[0]['database_type'] === 'mongodb' || databasesPayload[0]['database_type'] === 'dynamodb') {
                databasesPayload[0]['is_nosql'] = true;
                service.configurations[0]['is_nosql'] = true;
              } else {
                databasesPayload[0]['is_nosql'] = false;
                service.configurations[0]['is_nosql'] = false;
              }
              // configurationsForEnvCreation[environment]['partnerPayload']['databases'] = databasesPayload;
              // configurationsForEnvCreation[environment]['partnerPayload']['defaultDatabaseType'] = databasesPayload[0]['database_type'];

              if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('databases')) {
                delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['databases'];
              }
              if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
                delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['defaultDatabaseType'];
              }

              const dbAttributes = JSON.parse(JSON.stringify(databasesPayload[0]['database_attributes']));
              const attributes = Object.keys(dbAttributes);
              const result = {};
              if (attributes && attributes.length > 0) {
                for (let i = 0; i < attributes.length; i++) {
                  await this.platform.encryptAttribute(salt, iv, this.passphrase, dbAttributes[attributes[i]], this.keySize, this.iterationCount).then(response => {
                    result[attributes[i]] = response;
                  });
                }
              }
              service.configurations[0]['shash'] = salt;
              service.configurations[0]['ralam'] = iv;
              service.configurations[0]['database_type'] = databasesPayload[0]['database_type'];
              service.configurations[0]['database_name'] = 'default';
              service.configurations[0]['database_attributes'] = result;
              service.configurations[0]['region'] = '';
              service.configurations[0]['connection_provider'] = 'external';
              service.configurations[0]['audit_logs'][0] = {
                action: 'CREATE',
                by: localStorage.getItem('signInEmail'),
                at: Date.now()
              };
              configurationsForEnvCreation[environmentPayload]['selectedAPIGateway'] = this.selectedAPIGateway;

              await this.createEnvironment(configurationsForEnvCreation, environmentPayload, partnerShortCode).then(async response1 => {
                resolve(response1);
              });
            } else {

              if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('databases')) {
                delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['databases'];
              }
              if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
                delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['defaultDatabaseType'];
              }
              await this.createDatabaseAndCreateEnvironment(configurationsForEnvCreation, environmentPayload, databasesPayload, databaseSelected, partnerShortCode, salt, iv).then(async response1 => {
                resolve(response1);
              });
            }
          }
        }
      } else {
        resolve('failed');
        alert('Passwords do not match');
      }
    });
  }

  createDatabaseAndCreateEnvironment(configurationsForEnvCreation, environmentPayload, databasesPayload, databaseSelected, partnerShortCode, salt, iv) {
    return new Promise((resolve, reject) => {
      let dbName = '';
      if (environmentPayload === 'prod') {
        dbName = partnerShortCode;
      } else {
        dbName = environmentPayload + partnerShortCode;
      }
      this.platform.createDatabaseInApiplatform('admin-' + partnerShortCode, {
        databaseType: databaseSelected,
        databaseName: dbName
      }).then(async response => {
        const dbPayload = [{
          database_type: databaseSelected,
          database_name: 'default',
          database_attributes: {
            dbName: dbName
          },
          region: '',
          connection_provider: 'apiplatform',
          is_default: true
        }];
        if (databaseSelected === 'mongodb' || databaseSelected === 'dynamodb') {
          dbPayload[0]['is_nosql'] = true;
        } else {
          dbPayload[0]['is_nosql'] = false;
        }
        // configurationsForEnvCreation[environmentPayload]['partnerPayload']['databases'] = dbPayload;

        if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('databases')) {
          delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['databases'];
        }
        if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
          delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['defaultDatabaseType'];
        }

        for (const service of configurationsForEnvCreation[environmentPayload].settingsPayload.environments[0].services) {
          if (service.type === 'databases') {

            const dbAttributes = JSON.parse(JSON.stringify(dbPayload[0]['database_attributes']));
            const attributes = Object.keys(dbAttributes);
            const result = {};
            if (attributes && attributes.length > 0) {
              for (let i = 0; i < attributes.length; i++) {
                await this.platform.encryptAttribute(salt, iv, this.passphrase, dbAttributes[attributes[i]], this.keySize, this.iterationCount).then(response1 => {
                  result[attributes[i]] = response1;
                });
              }
            }

            service.configurations[0]['shash'] = salt;
            service.configurations[0]['ralam'] = iv;
            // service.configurations[0]['database_type'] = item['databases'][0]['database_type'];
            service.configurations[0]['database_type'] = databaseSelected;
            // service.configurations[0]['database_name'] = item['databases'][0]['database_name'];
            service.configurations[0]['database_name'] = 'default';
            service.configurations[0]['database_attributes'] = result;
            service.configurations[0]['region'] = '';
            service.configurations[0]['connection_provider'] = 'apiplatform';
            service.configurations[0]['audit_logs'][0] = {
              action: 'CREATE',
              by: localStorage.getItem('signInEmail'),
              at: Date.now()
            };
            if (databaseSelected === 'mongodb' || databaseSelected === 'dynamodb') {
              service.configurations[0]['is_nosql'] = true;
            } else {
              service.configurations[0]['is_nosql'] = false;
            }
          }
        }
        configurationsForEnvCreation[environmentPayload]['selectedAPIGateway'] = this.selectedAPIGateway;
        await this.createEnvironment(configurationsForEnvCreation, environmentPayload, partnerShortCode).then(async response1 => {
          resolve(response1);
        });
      }, async error => {
        for (const service of configurationsForEnvCreation[environmentPayload].settingsPayload.environments[0].services) {
          if (service.type === 'databases') {
            service.configurations = [];
          }
        }
        // configurationsForEnvCreation[environmentPayload]['partnerPayload']['databases'] = [];
        // configurationsForEnvCreation[environmentPayload]['selectedAPIGateway'] = this.selectedAPIGateway;
        if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('databases')) {
          delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['databases'];
        }
        if (configurationsForEnvCreation[environmentPayload]['partnerPayload'].hasOwnProperty('defaultDatabaseType')) {
          delete configurationsForEnvCreation[environmentPayload]['partnerPayload']['defaultDatabaseType'];
        }

        await this.createEnvironment(configurationsForEnvCreation, environmentPayload, partnerShortCode).then(async response1 => {
          resolve(response1);
        });
      });
    });
  }

  createEnvironment(configurationsForEnvCreation, environmentPayload, partnerShortCode) {
    return new Promise((resolve, reject) => {
      this.envManagerComponentInstance.temp[0] = environmentPayload;
      this.envManagerComponentInstance.partner = partnerShortCode;
      this.envManagerComponentInstance.isDirectNavigationWithoutDNSValidation = true;
      this.envManagerComponentInstance.isDuringOnboarding = true;
      this.envManagerComponentInstance.createEnvironment(configurationsForEnvCreation, 0).then(response => {
        this.environmentResponseArray = this.envManagerComponentInstance.envCreatorDnsValidationPayload;
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }
}
